import type { ReactNode } from 'react';

export const symbol_eraser_size_1: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M272-200q-29 0-50.5-21.27-21.5-21.28-21.5-51.15 0-13.58 5-26.08 5-12.5 16-23.5l417-417q11-11 24.18-16t26.82-5q29.29 0 50.14 21.15Q760-717.7 760-688q0 14-5.02 27.21Q749.96-647.57 739-637L323-221q-10.74 10.96-23.71 15.98T272-200Z"
		/>
	</svg>
);
